// for Dips and Sauces
import React, { useState } from "react";
import '../Styles/components.css';
import './CardStyles/CardE1.css';
import PopUp from "../PopUps/AddToCart_Popup/PopUp"

const PopupLayout = [{
  des: "none",
  options: "block",
  additional: "none",
  specialInstructions: "block",
}];
const CardE1 = (props,{ children, className ,...restProps},) => {
 
  const [openModal, setOpenModal]= useState(false);

const Popup = () => { 
  setOpenModal(true);

  // Disables Background Scrolling whilst the SideDrawer/Modal is open
  if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
  }
}

const ClosePopup = () => { 
  setOpenModal(false);

// Disables Background Scrolling whilst the SideDrawer/Modal is open
  document.body.style.overflow = 'unset';
  }
      return (
        <div
        onClick={Popup}
          {...restProps }
          className={`theme-div CardE1-div ${className}`}
        >
          <div className={`theme-div CardE1-div-0`}>
            <div className={`theme-div CardE1-div-1`}>
              <div className={`theme-div CardE1-div-2`}>
                <div className={`theme-div CardE1-div-3`}>
                  <div className={`theme-div CardE1-div-4`}>
                    <div className={`theme-div CardE1-div-5`}>
                      <h2 className={`theme-h2 CardE1-h2`}>{props.name}</h2>
                      <div className={`theme-div CardE1-div-6`}>
                        <button className={`theme-button CardE1-button`} type="button">
                          +
                        </button>
                      </div>
                    </div>
                    <div className={`theme-div CardE1-div-7`} />
                    <div className={`theme-div CardE1-div-8`}>
                      <div className={`theme-div CardE1-div-9`}>
                        <span className={`theme-span CardE1-span`}>Rs.{props.price}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`theme-div CardE1-div-10`}>
              <picture className={`theme-picture CardE1-picture`}>
                <source className={`theme-source CardE1-source`} type="image/webp" />
                <img className={`theme-img CardE1-img`} alt="" src={props.img} />
              </picture>
            </div>
          </div>
          {PopupLayout.map((display) => (
          <PopUp
          key={props.id}
          open={openModal}
          onClose={ClosePopup}
          name={props.name}
          id={props.id}
          price={props.price}
          des={props.des}
          img={props.img}
          displayDes={display.des}
          displayOption={display.options}
          displayAdditional={display.additional}
          displaySpecialInstruction={display.specialInstructions}
          />
          ))}
        </div>
      );
};
CardE1.defaultProps={
  name:"Name",
  price:"Price",
  des:'lorem ipsum lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsum ',
  img:"https://upload.wikimedia.org/wikipedia/commons/5/52/Fresh_Tomato_Sauce_%28Unsplash%29.jpg"
}

export default CardE1;